var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUsColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 6.86987H4.24756V21.9095H24.9998V6.86987Z",
    fill: "#FCB701"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 6.86987H4.24756V9.37647L13.4616 15.8936C14.1256 16.4785 15.0387 16.4785 15.7028 15.8936L24.9168 9.37647V6.86987H24.9998Z",
    fill: "#FCB701"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 5.19873H4.24756V6.8698L13.4616 15.4758C14.1256 16.0607 15.0387 16.0607 15.7028 15.4758L24.9998 6.8698V5.19873Z",
    fill: "#FCB701"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 5.19873H4.24756V6.45203H24.9998V5.19873Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15664 17.1469L3.66636 11.9666C3.00229 10.5462 3.74937 8.87515 5.24354 8.45738L6.57168 8.03961C6.98673 7.95606 7.23575 7.53829 7.15274 7.12053L6.65469 2.10733C6.57168 1.27179 5.65858 0.770473 4.9115 1.10469L3.66636 1.68956C2.50423 2.27443 1.67414 3.19352 1.42512 4.44682C-0.318076 12.1337 3.41733 20.1548 10.4731 23.5805C11.5522 24.0819 12.8804 24.0819 13.9595 23.5805L15.2046 22.9957C15.9517 22.6614 16.2007 21.5753 15.5367 20.9904L11.9673 17.3976C11.7182 17.1469 11.2202 17.0634 10.8882 17.314L9.72603 18.1496C8.5639 18.9851 6.82071 18.5673 6.15664 17.1469Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2048 22.9955C15.9519 22.6613 16.1179 21.7422 15.7028 21.1573L12.9635 18.3165C12.7145 18.0659 12.2164 17.9823 11.8844 18.233L10.7223 19.0685C9.47714 19.904 7.81696 19.4863 7.15289 18.233C6.73784 17.9823 6.40581 17.6481 6.15678 17.1468L3.66651 11.9665C3.00243 10.5461 3.74951 8.87499 5.24368 8.45722L6.57183 8.03946C6.98687 7.9559 7.2359 7.53814 7.15289 7.12037L6.65483 2.10717C6.65483 2.02362 6.65483 2.02362 6.65483 1.94006C6.3228 1.94006 6.07377 1.94006 5.74173 2.10717L4.57961 2.69204C3.41748 3.19336 2.58739 4.196 2.33836 5.36575C1.09322 10.8803 2.6704 16.4783 6.23979 20.5725C7.48493 21.7422 8.89608 22.8284 10.4733 23.5804C11.5524 24.0817 12.8805 24.0817 13.9596 23.5804L15.2048 22.9955Z",
    fill: "#00DCF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25 20.2383V5.19873",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5283 21.9095H24.9991V17.7318",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9986 21.0739L18.3579 15.6429",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81301 5.19873H24.9998V6.8698L15.7858 15.4758C15.1217 16.0607 14.2086 16.0607 13.5445 15.4758L7.73389 10.0448",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15664 17.1469L3.66636 11.9666C3.00229 10.5462 3.74937 8.87515 5.24353 8.45738L6.57168 8.03961C6.98673 7.95606 7.23575 7.53829 7.15274 7.12053L6.65469 2.10733C6.57168 1.27179 5.65858 0.770473 4.9115 1.10469L3.66636 1.68956C2.50423 2.27443 1.67414 3.19352 1.42512 4.44682C-0.318076 12.1337 3.41733 20.1548 10.4731 23.5805C11.5522 24.0819 12.8804 24.0819 13.9595 23.5805L15.2046 22.9957C15.9517 22.6614 16.2007 21.5753 15.5367 20.9904L11.9673 17.3976C11.7182 17.1469 11.2202 17.0634 10.8882 17.314L9.72603 18.1496C8.5639 18.9851 6.82071 18.5673 6.15664 17.1469Z",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32618 8.03957L4.74512 3.02637",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.71 21.9094L10.1406 18.3167",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsColor);
export default __webpack_public_path__ + "static/media/contact-us-color.70deb89ae1fbd6c7fcd32fd872235895.svg";
export { ForwardRef as ReactComponent };